module.exports = __webpack_public_path__ + "img/Infografis_ID_07.965f4443.jpg";